import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#pricing'
}: CTAButtonProps) {
  const content = <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`relative w-full group overflow-hidden rounded-xl bg-brand-dark p-[2px] shadow-lg shadow-gold-glow ${className}`} data-id="element-113">
      <div className="absolute inset-0 bg-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-114" />
      <div className="relative flex items-center justify-center gap-2 bg-gradient-to-r from-brand-light via-brand-green to-brand-green px-5 py-3 rounded-[10px] text-white font-montserrat font-bold text-base md:text-lg uppercase tracking-wide" data-id="element-115">
        {children}
        <ChevronRight className="w-5 h-5 text-white group-hover:translate-x-1 transition-transform" data-id="element-116" />
      </div>
    </motion.button>;
  if (href) {
    const isAnchor = href.startsWith('#');
    const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!isAnchor) return;
      e.preventDefault();
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'auto',
          block: 'start'
        });
      }
    };
    return <a href={href} onClick={handleAnchorClick} className="block w-full no-underline" data-id="element-117">
        {content}
      </a>;
  }
  return content;
}